import { PdHoverBox } from "./pd-hover-box/PdHoverBox.js";
//#region src/pd-hover-box/pd-hover-box.ts
var tag = "pd-hover-box";
if (!customElements.get(tag)) customElements.define(tag, PdHoverBox);
//#endregion
export { PdHoverBox };
